module.exports = __webpack_public_path__ + "static/media/Amazon_Alexa_blue_logo.45912583.svg";